import { Component, OnDestroy, inject, viewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Subject, Subscription, catchError, debounceTime, distinctUntilChanged } from 'rxjs';
import { ReceiptDatasourceService } from '../receipt-datasource.service';
import { ConfigItem } from 'src/app/api/api-user-management.service.generated';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-receipt-column-config',
  templateUrl: './receipt-column-config.component.html',
  styleUrls: ['./receipt-column-config.component.scss'],
  imports: [
    MatIconModule,
    MatCheckboxModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule
  ]
})
export class ReceiptColumnConfigComponent implements OnDestroy {
  dataSource = inject(ReceiptDatasourceService);

  readonly columnSelect = viewChild.required<MatSelect>('columnSelect');
  readonly menuTrigger = viewChild.required<MatMenuTrigger>('menuTrigger');

  private columnsChanged$ = new Subject<any>();
  private columnsSubscription: Subscription | undefined;

  columns: ConfigItem;
  showDropdown = false;

  async ngOnInit() {
    this.columnsSubscription = this.columnsChanged$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        catchError(error => {
          throw error;
        })
      )
      .subscribe(() => {
        this.updateColumnConfigs();
        this.menuTrigger().closeMenu();
      });

    await this.dataSource.initColumnConfig();
    this.columns = this.dataSource.userConfig?.configs?.find(config => config?.name == 'columnConfig');
    this.columns.value = this.columns.value.filter((col: any) =>
      col.property != 'id' &&
      col.property != 'preview' &&
      col.property != 'fraudDecision'
    );
  }

  ngOnDestroy() {
    if (this.columnsSubscription) {
      this.columnsSubscription.unsubscribe();
    }
  }

  openColumnSelect(): void {
    this.columnSelect().open();
  }

  toggleColumnVisibility(column: any) {
    column.isVisible = !column.isVisible;
    this.columnsChanged$.next(Math.random());
  }

  async updateColumnConfigs() {
    await this.dataSource.updateColumnConfig(this.columns.value);
    this.columns = this.dataSource.userConfig?.configs?.find(config => config?.name == 'columnConfig');
  }

  toggleDropdownVisibility() {
    this.showDropdown = !this.showDropdown;
  }

  getVisibleColumnsCount(): number {
    return this.columns?.value?.filter((col: any) => col.isVisible).length || 0;
  }

  showAllColumns() {
    // Set all columns to visible
    this.columns?.value?.forEach((col: any) => {
      col.isVisible = true;
    });
    this.columnsChanged$.next(Math.random());
  }

  showDefaultColumns() {
    const defaultProperties = ['stage', 'decision', 'scanDate', 'userPhone', 'docId', 'campaignName'];

    this.columns?.value?.forEach((col: any) => {
      col.isVisible = defaultProperties.includes(col.property);
    });
    this.columnsChanged$.next(Math.random());
  }
}
